import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.pinkishRed,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.black,
  textColorLight: colors.white
};
export default accordion;